import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2 from "../../../../../services/iqApiV2";
import { LIST_DEALS_REQUEST, listDealsFailure, listDealsSuccess } from "../../../actions/opportunities/increaseDealSizeActions/listDealsActions";



async function listDeals(userId) {
    try {
      const response = await iq_api_v2.get('/deals/list_deals', {
        params: { user_id: userId },
        headers: {
          'Accept': 'application/json'
        }
      });
      return response?.data?.result;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }
  
  

// Worker Saga
function* listDealsSaga() {
  try {
    const payload = yield select(
      (state) => state?.listDealsReducer?.payload
    );
    const {userId } = payload;
    const data = yield call(
        listDeals,  userId
    );
    yield put(listDealsSuccess(data));
  } catch (error) {
    yield put(listDealsFailure(error.message));
  }
}

// Watcher Saga
export function* watchListDealsSaga() {
  yield takeLatest(LIST_DEALS_REQUEST, listDealsSaga);
}
